const actions = {
    // List
    KNOWLEDGE_BASE_BEGIN: 'KNOWLEDGE_BASE_BEGIN',
    KNOWLEDGE_BASE_SUCCESS: 'KNOWLEDGE_BASE_SUCCESS',
    KNOWLEDGE_BASE_ERR: 'KNOWLEDGE_BASE_ERR',

    // Add
    KNOWLEDGE_BASE_ADD_BEGIN: 'KNOWLEDGE_BASE_ADD_BEGIN',
    KNOWLEDGE_BASE_ADD_SUCCESS: 'KNOWLEDGE_BASE_ADD_SUCCESS',
    KNOWLEDGE_BASE_ADD_ERR: 'KNOWLEDGE_BASE_ADD_ERR',

    // Update
    KNOWLEDGE_BASE_UPDATE_BEGIN: 'KNOWLEDGE_BASE_UPDATE_BEGIN',
    KNOWLEDGE_BASE_UPDATE_SUCCESS: 'KNOWLEDGE_BASE_UPDATE_SUCCESS',
    KNOWLEDGE_BASE_UPDATE_ERR: 'KNOWLEDGE_BASE_UPDATE_ERR',

    // Delete
    KNOWLEDGE_BASE_DELETE_BEGIN: 'KNOWLEDGE_BASE_DELETE_BEGIN',
    KNOWLEDGE_BASE_DELETE_SUCCESS: 'KNOWLEDGE_BASE_DELETE_SUCCESS',
    KNOWLEDGE_BASE_DELETE_ERR: 'KNOWLEDGE_BASE_DELETE_ERR',

    // Group Add
    KNOWLEDGE_BASE_GROUP_ADD_BEGIN: 'KNOWLEDGE_BASE_GROUP_ADD_BEGIN',
    KNOWLEDGE_BASE_GROUP_ADD_SUCCESS: 'KNOWLEDGE_BASE_GROUP_ADD_SUCCESS',
    KNOWLEDGE_BASE_GROUP_ADD_ERR: 'KNOWLEDGE_BASE_GROUP_ADD_ERR',

    // Group Update
    KNOWLEDGE_BASE_GROUP_UPDATE_BEGIN: 'KNOWLEDGE_BASE_GROUP_UPDATE_BEGIN',
    KNOWLEDGE_BASE_GROUP_UPDATE_SUCCESS: 'KNOWLEDGE_BASE_GROUP_UPDATE_SUCCESS',
    KNOWLEDGE_BASE_GROUP_UPDATE_ERR: 'KNOWLEDGE_BASE_GROUP_UPDATE_ERR',

    // Group Delete
    KNOWLEDGE_BASE_GROUP_DELETE_BEGIN: 'KNOWLEDGE_BASE_GROUP_DELETE_BEGIN',
    KNOWLEDGE_BASE_GROUP_DELETE_SUCCESS: 'KNOWLEDGE_BASE_GROUP_DELETE_SUCCESS',
    KNOWLEDGE_BASE_GROUP_DELETE_ERR: 'KNOWLEDGE_BASE_GROUP_DELETE_ERR',

    // Update Status
    KNOWLEDGE_BASE_UPDATE_STATUS_BEGIN: 'KNOWLEDGE_BASE_UPDATE_STATUS_BEGIN',
    KNOWLEDGE_BASE_UPDATE_STATUS_SUCCESS: 'KNOWLEDGE_BASE_UPDATE_STATUS_SUCCESS',
    KNOWLEDGE_BASE_UPDATE_STATUS_ERR: 'KNOWLEDGE_BASE_UPDATE_STATUS_ERR',

    // Learn from Past Conversations
    KNOWLEDGE_BASE_LEARN_BEGIN: 'KNOWLEDGE_BASE_LEARN_BEGIN',
    KNOWLEDGE_BASE_LEARN_SUCCESS: 'KNOWLEDGE_BASE_LEARN_SUCCESS',
    KNOWLEDGE_BASE_LEARN_ERR: 'KNOWLEDGE_BASE_LEARN_ERR',

    // Bulk Add (from conversation suggestions)
    KNOWLEDGE_BASE_BULK_ADD_BEGIN: 'KNOWLEDGE_BASE_BULK_ADD_BEGIN',
    KNOWLEDGE_BASE_BULK_ADD_SUCCESS: 'KNOWLEDGE_BASE_BULK_ADD_SUCCESS',
    KNOWLEDGE_BASE_BULK_ADD_ERR: 'KNOWLEDGE_BASE_BULK_ADD_ERR',

    knowledgeBaseBegin: () => ({ type: actions.KNOWLEDGE_BASE_BEGIN }),
    knowledgeBaseSuccess: (data) => ({ type: actions.KNOWLEDGE_BASE_SUCCESS, data }),
    knowledgeBaseErr: (err) => ({ type: actions.KNOWLEDGE_BASE_ERR, err }),

    knowledgeBaseAddBegin: () => ({ type: actions.KNOWLEDGE_BASE_ADD_BEGIN }),
    knowledgeBaseAddSuccess: () => ({ type: actions.KNOWLEDGE_BASE_ADD_SUCCESS }),
    knowledgeBaseAddErr: (err) => ({ type: actions.KNOWLEDGE_BASE_ADD_ERR, err }),

    knowledgeBaseUpdateBegin: () => ({ type: actions.KNOWLEDGE_BASE_UPDATE_BEGIN }),
    knowledgeBaseUpdateSuccess: () => ({ type: actions.KNOWLEDGE_BASE_UPDATE_SUCCESS }),
    knowledgeBaseUpdateErr: (err) => ({ type: actions.KNOWLEDGE_BASE_UPDATE_ERR, err }),

    knowledgeBaseDeleteBegin: () => ({ type: actions.KNOWLEDGE_BASE_DELETE_BEGIN }),
    knowledgeBaseDeleteSuccess: () => ({ type: actions.KNOWLEDGE_BASE_DELETE_SUCCESS }),
    knowledgeBaseDeleteErr: (err) => ({ type: actions.KNOWLEDGE_BASE_DELETE_ERR, err }),

    knowledgeBaseGroupAddBegin: () => ({ type: actions.KNOWLEDGE_BASE_GROUP_ADD_BEGIN }),
    knowledgeBaseGroupAddSuccess: () => ({ type: actions.KNOWLEDGE_BASE_GROUP_ADD_SUCCESS }),
    knowledgeBaseGroupAddErr: (err) => ({ type: actions.KNOWLEDGE_BASE_GROUP_ADD_ERR, err }),

    knowledgeBaseGroupUpdateBegin: () => ({ type: actions.KNOWLEDGE_BASE_GROUP_UPDATE_BEGIN }),
    knowledgeBaseGroupUpdateSuccess: () => ({ type: actions.KNOWLEDGE_BASE_GROUP_UPDATE_SUCCESS }),
    knowledgeBaseGroupUpdateErr: (err) => ({ type: actions.KNOWLEDGE_BASE_GROUP_UPDATE_ERR, err }),

    knowledgeBaseGroupDeleteBegin: () => ({ type: actions.KNOWLEDGE_BASE_GROUP_DELETE_BEGIN }),
    knowledgeBaseGroupDeleteSuccess: () => ({ type: actions.KNOWLEDGE_BASE_GROUP_DELETE_SUCCESS }),
    knowledgeBaseGroupDeleteErr: (err) => ({ type: actions.KNOWLEDGE_BASE_GROUP_DELETE_ERR, err }),

    knowledgeBaseUpdateStatusBegin: () => ({ type: actions.KNOWLEDGE_BASE_UPDATE_STATUS_BEGIN }),
    knowledgeBaseUpdateStatusSuccess: () => ({ type: actions.KNOWLEDGE_BASE_UPDATE_STATUS_SUCCESS }),
    knowledgeBaseUpdateStatusErr: (err) => ({ type: actions.KNOWLEDGE_BASE_UPDATE_STATUS_ERR, err }),

    knowledgeBaseLearnBegin: () => ({ type: actions.KNOWLEDGE_BASE_LEARN_BEGIN }),
    knowledgeBaseLearnSuccess: (data) => ({ type: actions.KNOWLEDGE_BASE_LEARN_SUCCESS, data }),
    knowledgeBaseLearnErr: (err) => ({ type: actions.KNOWLEDGE_BASE_LEARN_ERR, err }),

    knowledgeBaseBulkAddBegin: () => ({ type: actions.KNOWLEDGE_BASE_BULK_ADD_BEGIN }),
    knowledgeBaseBulkAddSuccess: () => ({ type: actions.KNOWLEDGE_BASE_BULK_ADD_SUCCESS }),
    knowledgeBaseBulkAddErr: (err) => ({ type: actions.KNOWLEDGE_BASE_BULK_ADD_ERR, err }),
};

export default actions;
